import { WEBSOCKET_CONNECTED_KEY } from "../constants";

/**Connection of WebScoket
 *
 * @param url
 * @param onMessageCallback
 * @param onOpenCallback
 * @param onErrorCallback
 * @param onCloseCallback
 * @returns
 */

export const createWebSocketConnection = (url, onMessageCallback, onOpenCallback, onErrorCallback, onCloseCallback) => {
  const retry = {
    minRetryAttempts: 0,
    maxRetryAttempts: 2,
  };

  const connectWebSocket = () => {
    const websocket = new WebSocket(url);

    websocket.onopen = () => {
      localStorage.setItem(WEBSOCKET_CONNECTED_KEY, "true");
      if (onOpenCallback) onOpenCallback();
    };

    websocket.onmessage = (event) => {
      if (typeof onMessageCallback === "function") {
        onMessageCallback(event.data);
      }
    };

    websocket.onerror = (errorEvent) => {
      if (onErrorCallback) onErrorCallback(errorEvent);
      websocket.close();
      attemptRetry();
    };

    websocket.onclose = () => {
      localStorage.setItem(WEBSOCKET_CONNECTED_KEY, "false");
      if (onCloseCallback) onCloseCallback();
    };

    return websocket;
  };

  const attemptRetry = () => {
    if (retry.minRetryAttempts < retry.maxRetryAttempts) {
      retry.minRetryAttempts++;
      setTimeout(() => {
        connectWebSocket();
        console.log(`Retry attempt ${retry.minRetryAttempts}`);
      }, 1000); // Retry after 1 second
    }
  };

  return connectWebSocket();
};

export const closeWebSocketConnection = (websocket) => {
  if (websocket && websocket.readyState === WebSocket.OPEN) {
    localStorage.setItem(WEBSOCKET_CONNECTED_KEY, "false");
    websocket.close();
  }
};
